import { render } from "./DialogResetAccount.vue?vue&type=template&id=065c0d7b"
import script from "./DialogResetAccount.vue?vue&type=script&lang=js"
export * from "./DialogResetAccount.vue?vue&type=script&lang=js"

import "./DialogResetAccount.vue?vue&type=style&index=0&id=065c0d7b&lang=scss"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__